module.exports = __webpack_public_path__ + "static/media/assa-phone.90416be3.svg";